import React from 'react';
import NotificationSystem from 'react-notification-system';

import { WELCOME_NOTIFICATION_DELAY } from '../constants';
import './Notification.css';
import './WelcomeNotification.css';

export default class WelcomeNotification extends React.PureComponent {
  renderNotificationMessage = () => {
    return (
      <div className="welcome-notification">
        <p>
          You might notice the game price has been dropped for new games. Feel free to play just for fun.
        </p>
        <p>
          To be notified about updates, or if you have any questions, get in touch on 
          Twitter <a className="twitter" href="https://twitter.com/hashheroes" target="_blank" rel="noopener noreferrer">@HashHeroes</a>.
        </p>
      </div>
    )
  }

  componentDidMount() {
    this.notificationSystem = this.refs.appNotificationSystem;
    setTimeout(() => {
        this.notificationSystem.addNotification({
            autoDismiss: 0,
            message: 'Hey!',
            level: 'warning', // todo: using warning for styles
            position: 'tc',
            children: this.renderNotificationMessage()
        });
    }, WELCOME_NOTIFICATION_DELAY);
  }

  render() {
    return (
      <NotificationSystem ref="appNotificationSystem" />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WelcomeNotification.js